/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_Open_TaskInputs */

const cs_matches_open_task = /** @type {(inputs: Matches_Open_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-up úkol`)
};

const en_matches_open_task = /** @type {(inputs: Matches_Open_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-up task`)
};

/**
* | output |
* | --- |
* | "Follow-up task" |
*
* @param {Matches_Open_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_open_task = /** @type {((inputs?: Matches_Open_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_Open_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_open_task(inputs)
	return cs_matches_open_task(inputs)
});